var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button-vue',{attrs:{"condition":_vm.condition},on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.condition.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }